const config = {
  endpoints: {
    warehouse: import.meta.env.VITE_WAREHOUSE_API_URL || '/warehouse',
    merchants: import.meta.env.VITE_MERCHANTS_API_URL || '/merchants',
    billing: import.meta.env.VITE_BILLING_API_URL || '/billing-api'
  },
  // API key is optional - app works with mocked data when not configured
  apiKey: import.meta.env.VITE_API_KEY || '',
  defaultOrgId: Number(import.meta.env.VITE_DEFAULT_ORG_ID) || 14791296,
  defaultAccountId: Number(import.meta.env.VITE_DEFAULT_ACCOUNT_ID) || 1312312,
  // When true (or no API key), all services skip real API calls and serve mock data immediately
  useMock: import.meta.env.VITE_USE_MOCK === 'true' || !import.meta.env.VITE_API_KEY,
  // WebSocket URL for real-time updates
  wsUrl: import.meta.env.VITE_WS_URL || 'ws://localhost:3001',
  // Keycloak auth (integrated via a same-origin BFF; browser never talks to Keycloak directly).
  // When VITE_KEYCLOAK_ENABLED !== 'true' the auth layer falls back to the in-memory mock so the
  // app remains fully functional in preview without a running Keycloak server.
  keycloak: {
    enabled: import.meta.env.VITE_KEYCLOAK_ENABLED === 'true',
    // Base path of the server-side auth proxy that brokers Keycloak token/admin/OIDC calls.
    authBasePath: import.meta.env.VITE_AUTH_BASE_PATH || '/auth',
    // Informational only (surfaced to the BFF); safe public client values.
    realm: import.meta.env.VITE_KEYCLOAK_REALM || 'barracuda',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'barracuda-web',
  },
}

export default config
